import { pick } from 'ramda'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { parseComponentTypes } from '@/utils'
import { ComponentType } from '@/utils/api'

import { InlineSignupSettings } from './Settings'

export type inlineSignupData =
  | { settings: InlineSignupSettings }
  | string
  | null
  | undefined

export const parseInlineSignupData = (
  orgSlug?: string,
  param?: inlineSignupData
) => {
  if (!orgSlug || !param) return {}
  const data = parseComponentTypes(param, ComponentType.inlineSignup)

  if (!data) return {}
  const filteredSettings = pick(
    [
      'FirstNamePrompt',
      'LastNamePrompt',
      'DateOfBirthPrompt',
      'PatientIdentifierPrompt',
    ],
    data.settings
  )
  return {
    data: filteredSettings,
    organization: orgSlug,
    schemaName: 'InLineSignUpConfig',
    schemaVersion: '1.0.0',
    version: '1.0.0',
  }
}

export const useParseInlineSignupData = (
  orgSlug?: string,
  param?: inlineSignupData
) =>
  useMemo(() => {
    return parseInlineSignupData(orgSlug, param)
  }, [param, orgSlug])

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)

  const current = useGetCustomComponent<InlineSignupSettings>(componentID)
  const config = useParseInlineSignupData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)
  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Inline Signup"
      valid={valid}
    />
  )
}
